import React from 'react';
import { useSelector } from 'react-redux';
import { getBroadcastersState } from '../store/selectors/broadcastersSelector';
import Broadcasters from '../Broadcasters';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import broadcastersReducer from '../store/reducers/broadcasters';
import scheduleDataSource from '@gameday/core/datasources/schedule';
import broadcastersDataRequestAction from '../store/actions/broadcastersDataRequestAction';

const fetchData = () => {
    return broadcastersDataRequestAction();
};

initContainerData.register({
    datasources: {
        schedule: scheduleDataSource
    },
    reducers: {
        broadcasters: broadcastersReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const BroadcastersDataContainer = ({ tvOnlyString }) => {
    const broadcastersState = useSelector(getBroadcastersState);
    return (
        <Broadcasters { ...broadcastersState } tvOnlyString={tvOnlyString} />
    );
};

export default BroadcastersDataContainer;
export { fetchData, routes };
